import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import useAlertFromLocation from "../../../../hooks/useAlertFromLocation";
import Alert from "../../../Common/Alert";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const [receiveData, setReceiveData] = useState([]);
  const [loading, setLoading] = useState(false);

  const alert = useAlertFromLocation();

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await Http.get("/demand-forecast");
      setReceiveData(res.data);
    } catch (e) {
      console.error("Fetch error:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteForecast = (code) => {
    Swal.fire({
      title: "Are you sure?",
      text: `All forecasts with code ${code} will be deleted.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete(`/demand-forecast/${code}`)
          .then((res) => {
            Swal.fire("Deleted!", res.data.message, "success");
            fetchData();
          })
          .catch((e) => {
            Swal.fire("Failed!", e.response?.data?.message || "Something went wrong.", "error");
          });
      }
    });
  };

  const cols = [
    { field: "code", header: "Code" },
    { field: "start_date", header: "Start Date" },
    { field: "end_date", header: "End Date" },
    { field: "forecasting_duration", header: "Forecasting Month" },
    { field: "product_count", header: "Products" },
  ];

  const actionTemplate = (item) => (
    <td className="text-right" style={{ whiteSpace: "nowrap" }}>
      <Link to={"/demand-forecast-view/" + item.code} className="btn btn-info btn-sm" title="View">
        <i className="fa fa-eye"></i>
      </Link>
      <Link to={"/edit-demand-forecast/" + item.code} className="btn btn-primary btn-sm ms-1" title="Edit">
        <i className="fa fa-pencil"></i>
      </Link>
      <button className="btn btn-danger btn-sm ms-1" title="Delete" onClick={() => deleteForecast(item.code)}>
        <i className="fa fa-trash"></i>
      </button>
    </td>
  );

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Demand Forecasting List</h5>
          <Link to="/create-demand-forecast" className="btn btn-primary">
            <i className="fa fa-plus-square mg-r-6"></i> Add Forecast
          </Link>
        </div>
        <div className="am-pagebody">
          <Alert alert={alert} />
          <div className="card pd-20 pd-sm-40">
            <ReactDataTable cols={cols} receiveData={receiveData} isLoading={loading} actionTemplate={actionTemplate} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
